import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GatekeeperKeyPage } from './gatekeeper.page';
import { modalGuard } from '../../../core/guards/modal/modal.guard';

const routes: Routes = [
  {
    path: '',
    component: GatekeeperKeyPage,
    canDeactivate: [modalGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GatekeeperPageRoutingModule {}
